export default __webpack_public_path__ + "static/media/ilustra-mobile.7f3ac727.svg";